export default "__VITE_ASSET__COZPkg_1__"